module.exports = __webpack_public_path__ + "images/aiways_smalld5b1066771a025945f64eb20a02e817c.png";